<a class="brand" routerLink="/dashboard"><app-logo /></a>

<nav [attr.aria-label]="'sidebar.aria-label' | translate">
    @for (item of menuItems(); track item.label) {
        @if (item.children) {
            <app-menu-header
                [label]="item.label | translate"
                [collapsed]="isCollapsed(item.label)"
                [class.pinned]="item.pinToBottom"
                (toggleCollapse)="toggleHeader(item.label)"
            />
            @if (!isCollapsed(item.label)) {
                @for (child of item.children; track child.label) {
                    @if (child.routerLink) {
                        <app-menu-item
                            [label]="child.label | translate"
                            [icon]="child.icon"
                            [link]="child.routerLink"
                            [exact]="!!child.exact"
                            [testId]="child.testId"
                        />
                    }
                }
            }
        } @else if (item.routerLink) {
            <app-menu-item [label]="item.label | translate" [icon]="item.icon" [link]="item.routerLink" [testId]="item.testId" />
        }
    }
</nav>

<app-account />
